import {CanDeactivateFn} from '@angular/router';
import {Observable} from 'rxjs';

/**
 * Interfaccia da implementare sui componenti che ospitano un DynamicFormComponent.
 *
 * Il metodo canDeactivate() viene chiamato dal router prima di abbandonare la pagina.
 * Deve restituire true (lascia uscire) o false (blocca la navigazione).
 *
 * Implementazione tipica nel componente pagina:
 * ```ts
 * canDeactivate(): Observable<boolean> {
 *   return this.dynamicFormRef.canDeactivate();
 * }
 * ```
 */
export interface HasUnsavedChanges {
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean;
}

/**
 * Guard funzionale che delega la logica al componente corrente.
 *
 * Registrazione nel routing:
 * ```ts
 * {
 *   path: 'anagrafica',
 *   component: AnagraficaPageComponent,
 *   canDeactivate: [unsavedChangesGuard]
 * }
 * ```
 */
export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> =
  (component) => component.canDeactivate();
